<template>
  <div
    v-loading="loading"
    element-loading-text="Hang in there..."
  >
    <div class="flex justify-flex-end">
      <el-radio-group v-model="range">
        <el-radio-button label="day">
          Day
        </el-radio-button>
        <el-radio-button label="week">
          Week
        </el-radio-button>
        <el-radio-button label="month">
          Month
        </el-radio-button>
        <el-radio-button label="year">
          Year
        </el-radio-button>
      </el-radio-group>
    </div>

    <div
      class="statistics-bubbles flex"
    >
      <div class="flex card-container">
        <card
          title="New Candidate Accounts"
          :value="statistics[range].candidateSignUps"
          type="new-candidate-accounts"
        />
      </div>
      <div class="flex card-container">
        <card
          title="New Company Accounts"
          :value="statistics[range].companySignUps"
          type="new-company-accounts"
        />
      </div>
      <div class="flex card-container">
        <card
          title="Completed Assessments"
          :value="statistics[range].completedAssessments"
          type="completed-assessments"
        />
      </div>
      <div class="flex card-container">
        <card
          title="Expiring Accounts"
          :value="statistics[range].expiringLeads.length"
          type="expiring-leads"
        />
      </div>
    </div>

    <div class="flex width-100">
      <div class="flex-1 chart-container">
        <LineChart :chart-data="statistics" />
      </div>
      <div class="width-50 table-container">
        <div class="leads-table">
          <h3>{{ tableRangeTitle }} Leads</h3>

          <el-table
            border
            :data="statistics[tableRange].newLeads"
          >
            <el-table-column
              width="110"
              prop="firstName"
              label="First Name"
            />
            <el-table-column
              width="110"
              prop="lastName"
              label="Last Name"
            />
            <el-table-column
              width="220"
              prop="email"
              label="Email"
            />
            <el-table-column
              prop="organization.name"
              label="Organization"
            />
            <el-table-column
              prop="profile.createdDate"
              label="Date Created"
            >
              <template slot-scope="scope">
                {{ displayDate(scope.row.profile.createdDate) }}
              </template>
            </el-table-column>
          </el-table>
        </div>

        <div class="leads-table">
          <h3>{{ tableRangeTitle }} Expiring Accounts</h3>

          <el-table
            border
            :data="statistics[tableRange].expiringLeads"
          >
            <el-table-column
              width="110"
              prop="firstName"
              label="First Name"
            />
            <el-table-column
              width="110"
              prop="lastName"
              label="Last Name"
            />
            <el-table-column
              width="220"
              prop="email"
              label="Email"
            />
            <el-table-column
              prop="organization.name"
              label="Organization"
            />
            <el-table-column
              prop="profile.expirationDate"
              label="Expiration Date"
            >
              <template slot-scope="scope">
                {{ displayDate(scope.row.profile.expirationDate) }}
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import LineChart from '@/components/Charts/Line/Line'
import Card from '@/components/Stats/Card'
export default {
  name: 'Dashboard',
  components: {
    LineChart,
    Card
  },
  data() {
    return {
      range: 'day'
    }
  },
  computed: {
    tableRange() {
      if (this.range === 'month' || this.range === 'year') {
        return 'week'
      }

      return this.range
    },

    tableRangeTitle() {
      return this.range === 'week' ? "Week's" : "Today's"
    },

    statistics() {
      return this.$store.getters.dashboardStatistics
    },

    loading() {
      return this.$store.getters.getLoading
    }
  }
}
</script>

<style lang="scss" scoped>
  @import "~vars";

  .card-container {
    width: 100%;
  }

  .chart-container {
    background-color: white;
    padding: $-padding-unit * 2;
  }

  .statistics-bubbles {
    margin: ($-padding-unit * 4) 0;
  }

  .table-container {
    padding: $-padding-unit * 2;
  }

  .leads-table {
    margin-bottom: $-padding-unit * 4;
  }

  .width-50 {
    width: 50%;
  }
</style>
